import { useQuery } from 'react-query';

import { LIST } from '../../constants/queryDefinition';
import ListService from '../../../services/ListService';
import FilterService from '../../../services/FilterService';

const listService = ListService.get();

// Returns a list of the authenticated user's Filter lists.
export default function useFilterList(tradeState: number) {
  return useQuery(
    [LIST.FILTERLIST.KEY],
    async () => {
      const filterListResponse = await listService.getList(tradeState);

      FilterService.sortUserFilterList(filterListResponse?.summaries);

      return filterListResponse;
    },
    {
      placeholderData: {},
      refetchOnMount: true,
      cacheTime: LIST.FILTERLIST.STALE_TIME
    }
  );
}
